module.exports = __webpack_public_path__ + "img/news8-1.10d01f61.png";